import { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import { useEntityCrud } from '../../../hooks/useEntityCrud'
import { toast } from 'react-toastify'
import { SortableContainer,SortableElement } from 'react-sortable-hoc'
import { arrayMove } from 'react-sortable-hoc'

const Index = () => {

    const { readData } = useEntityCrud('Support/getTopics')
    const { addData: updateRowsOrder } = useEntityCrud('Support/reorderTopics')
    const { readData: changeRowStatus } = useEntityCrud('Support/changeTopicsStatus')

    const [rows,setRows] = useState([])

    const getData = () => {
        readData().then(({data}) => {
            if(data.status)
                setRows(data.result)
        })
    }

    useEffect(() => {
        getData()
    },[])

    const changeStatus = (id,isActive) => {
        const postedData = {
            id,
            isActive
        }
        changeRowStatus(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت موضوع مورد نظر به روزرسانی شد')
                getData()
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    const SortableItem = SortableElement(({ value }) => <div className="row border-bottom mb-3 pb-1 bg-white" style={{cursor: 'move'}}>
        <div className="col-md-1">
            {value.id}
        </div>
        <div className="col-md-5">
            {value.title}
        </div>
        <div className="col-md-3">
            {value.isActive ? 'فعال' : 'غیرفعال'}
        </div>
        <div className="col-md-3">
            <button className={`btn btn-icon mb-0 btn-${value.isActive ? 'danger' : 'success'}`} title={value.isActive ? 'غیرفعال سازی' : 'فعال سازی'} onClick={() => changeStatus(value.id,!value.isActive)}><i className={`fe fe-${value.isActive ? 'x' : 'check'}`}></i></button>
        </div>
    </div>)

    const SortableList = SortableContainer(({ items }) => {
        return (
            <ul>
                {items.map((value,index) => (
                    <SortableItem key={`item-${value.id}`} index={index} value={value} />
                ))}
            </ul>
        )
      })

    const onSortEnd = ({ oldIndex,newIndex }) => {
        const allRows = [...rows]
        const sortedRows = arrayMove(allRows,oldIndex,newIndex)
        setRows([...sortedRows])
        const rowsOrder = []
        sortedRows.map((row,index) => rowsOrder.push({
            id: row.id,
            order: ++index
        }))
        updateRowsOrder(rowsOrder)
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">لیست موضوعات</div>
            </div>
            <div className="card-body p-4">
                <Link className="btn btn-primary mb-3" to="categories/create">ایجاد موضوع جدید</Link>
                {rows.length ? <>
                    <div className="row border-bottom mb-3 pb-3">
                        <div className="col-md-1">ردیف</div>
                        <div className="col-md-5">عنوان</div>
                        <div className="col-md-3">وضعیت</div>
                        <div className="col-md-3">عملیات</div>
                    </div>
                    <SortableList items={[...rows]} onSortEnd={onSortEnd} />

                    {/* {rows.map((row,index) => 
                    <div className="row" key={index}>
                        <div className="col-md-1">
                            {++index}
                        </div>
                        <div className="col-md-5">
                            {row.title}
                        </div>
                        <div className="col-md-3">
                            {row.isActive ? 'فعال' : 'غیرفعال'}
                        </div>
                        <div className="col-md-3">
                            <button className={`btn btn-icon mb-0 btn-${row.isActive ? 'danger' : 'success'}`} title={row.isActive ? 'غیرفعال سازی' : 'فعال سازی'} onClick={() => changeStatus(row.id,!row.isActive)}><i className={`fe fe-${row.isActive ? 'x' : 'check'}`}></i></button>
                        </div>
                    </div>
                )} */}

                     </> : <div className="alert alert-info mb-0"><p className="mb-0">موضوعی در سیستم ثبت نشده است</p></div>}
            </div>
        </div>
    )
}

export default Index